import React from 'react'
import PropTypes from 'prop-types'
import { Controller } from 'react-hook-form'
import SydLabel, { hookFormErrorAdapter } from '../../../../commonDesign/SydLabel'
import { buildValidationRules } from '../utils/fieldUtils'
import SydDateInput from './components/SydDateInput'

function DateFieldEditor ({ field, control, form }) {
  const baseRules = buildValidationRules(field)
  const isRequired = field.validations?.required || field.required

  // Add date validation
  const rules = {
    ...baseRules,
    validate: {
      ...(baseRules.validate || {}),
      validDate: (value) => {
        if (!value || value === '') return true
        // Check if value is in YYYY-MM-DD format
        const dateRegex = /^\d{4}-\d{2}-\d{2}$/
        if (!dateRegex.test(value)) {
          return 'Invalid date format.'
        }
        // Check if it's a valid date
        const date = new Date(value)
        if (isNaN(date.getTime())) {
          return 'Invalid date.'
        }
        return true
      }
    }
  }

  return (
    <Controller
      name={field.id}
      control={control}
      rules={rules}
      render={({ field: hookField, fieldState }) => (
        <SydLabel
          label={field.label}
          required={isRequired}
          error={hookFormErrorAdapter(form, fieldState)}
          description={field.description}
        >
          <SydDateInput
            {...hookField}
          />
        </SydLabel>
      )}
    />
  )
}

DateFieldEditor.propTypes = {
  field: PropTypes.shape({
    id: PropTypes.string.isRequired,
    label: PropTypes.string.isRequired,
    description: PropTypes.string,
    required: PropTypes.bool,
    validations: PropTypes.object,
    validationRules: PropTypes.object
  }).isRequired,
  control: PropTypes.object.isRequired,
  form: PropTypes.object.isRequired
}

export default DateFieldEditor
